<button type="button"  *ngIf="!this.orderData || !this.orderData.exceptionReport || !this.orderData.exceptionReport.commentExistForCurrentWeek" [disabled]="isDisabled" class="pin-order-cell-button datacenter-total-hidden"
	mat-icon-button color="primary" (click)="openPinOrder()">
	<mat-icon svgIcon="md:pin"></mat-icon>
</button>
<button type="button"  *ngIf="this.orderData && this.orderData.exceptionReport && this.orderData.exceptionReport.commentExistForCurrentWeek" [disabled]="isDisabled" class="pin-order-cell-button datacenter-total-hidden"
	mat-icon-button color="primary" (click)="openPinOrder()">
	<mat-icon svgIcon="md:pinFilled"></mat-icon>
</button>
